import React from 'react';
import {
  HalloweenCardCornerWeb,
  HalloweenPumpkinIcon,
  HalloweenBatIcon
} from './halloween/HalloweenIcons';

/* ==========================================================================
   CHRISTMAS ICONS (Winter Wonderland)
   ========================================================================== */

export const ChristmasSnowflakeIcon = ({ className = 'w-4 h-4', style = {}, ...props }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} style={style} {...props}>
    <line x1="12" y1="2" x2="12" y2="22" />
    <line x1="12" y1="6" x2="9" y2="4" />
    <line x1="12" y1="6" x2="15" y2="4" />
    <line x1="12" y1="18" x2="9" y2="20" />
    <line x1="12" y1="18" x2="15" y2="20" />
    <line x1="3.34" y1="7" x2="20.66" y2="17" />
    <line x1="6.8" y1="9" x2="4" y2="11" />
    <line x1="6.8" y1="9" x2="6.8" y2="5.5" />
    <line x1="17.2" y1="15" x2="20" y2="13" />
    <line x1="17.2" y1="15" x2="17.2" y2="18.5" />
    <line x1="3.34" y1="17" x2="20.66" y2="7" />
    <line x1="6.8" y1="15" x2="4" y2="13" />
    <line x1="6.8" y1="15" x2="6.8" y2="18.5" />
    <line x1="17.2" y1="9" x2="20" y2="11" />
    <line x1="17.2" y1="9" x2="17.2" y2="5.5" />
  </svg>
);

export const ChristmasCardCornerFrost = ({ className = 'w-9 h-9' }) => (
  <div className="absolute top-0 right-0 pointer-events-none z-10 opacity-75 group-hover:opacity-100 transition-opacity">
    <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M36 0 L0 0 C4 8 10 14 18 18 C22 26 28 32 36 36 Z" fill="rgba(56, 189, 248, 0.12)" />
      <path d="M36 4 C24 4 14 14 4 36" stroke="#38bdf8" strokeWidth="1" strokeDasharray="2 2" opacity="0.8" />
      <circle cx="28" cy="8" r="1.5" fill="#38bdf8" />
      <circle cx="20" cy="16" r="1.2" fill="#bae6fd" />
      <circle cx="12" cy="24" r="1.2" fill="#38bdf8" />
      <circle cx="8" cy="28" r="1" fill="#bae6fd" />
    </svg>
  </div>
);

/* ==========================================================================
   DIWALI ICONS (Festival of Lights)
   ========================================================================== */

export const DiwaliDiyaIcon = ({ className = 'w-4 h-4', style = {}, ...props }) => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} style={style} {...props}>
    <defs>
      <linearGradient id="pshDiyaFlameCard" x1="0%" y1="100%" x2="0%" y2="0%">
        <stop offset="0%" stopColor="#ea580c" />
        <stop offset="50%" stopColor="#f59e0b" />
        <stop offset="100%" stopColor="#fef08a" />
      </linearGradient>
      <linearGradient id="pshDiyaClayCard" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#d97706" />
        <stop offset="100%" stopColor="#78350f" />
      </linearGradient>
    </defs>
    <path d="M6 19 C8 26 13 29 16 29 C19 29 24 26 26 19 C27 18 25 17 23 17.5 C19 19 13 19 9 17.5 C7 17 5 18 6 19 Z" fill="url(#pshDiyaClayCard)" stroke="#b45309" strokeWidth="0.8" />
    <ellipse cx="16" cy="18" rx="10" ry="2.5" fill="#f59e0b" stroke="#fde047" strokeWidth="0.6" />
    <path d="M16 4 C13 10 11 13 14 17 C15 18.5 17 18.5 18 17 C21 13 19 10 16 4 Z" fill="url(#pshDiyaFlameCard)" />
    <path d="M16 8 C14.5 11 13.8 13 15 16 C15.5 17 16.5 17 17 16 C18.2 13 17.5 11 16 8 Z" fill="#ffffff" opacity="0.9" />
  </svg>
);

export const DiwaliSparklerIcon = ({ className = 'w-4 h-4', style = {}, ...props }) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} style={style} {...props}>
    <path d="M12 2 L12 22 M2 12 L22 12 M5 5 L19 19 M5 19 L19 5" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="12" cy="12" r="2.5" fill="#fde047" />
    <circle cx="12" cy="4" r="1" fill="#fef08a" />
    <circle cx="12" cy="20" r="1" fill="#fef08a" />
    <circle cx="4" cy="12" r="1" fill="#fef08a" />
    <circle cx="20" cy="12" r="1" fill="#fef08a" />
  </svg>
);

export const DiwaliCardCornerRangoli = ({ className = 'w-9 h-9' }) => (
  <div className="absolute top-0 right-0 pointer-events-none z-10 opacity-75 group-hover:opacity-100 transition-opacity">
    <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M36 0 L12 0 C12 13.2 22.8 24 36 24 Z" fill="rgba(245, 158, 11, 0.12)" />
      <path d="M36 0 C22.7 0 12 10.7 12 24 C12 28 13.5 31.8 16 35 L36 35 Z" fill="rgba(239, 68, 68, 0.08)" />
      <path d="M36 8 C27 8 20 15 20 24" stroke="#f59e0b" strokeWidth="1" strokeDasharray="2 1" />
      <path d="M36 16 C30 16 26 20 26 26" stroke="#fde047" strokeWidth="0.8" />
      <circle cx="26" cy="10" r="1.5" fill="#f59e0b" />
      <circle cx="20" cy="16" r="1.2" fill="#ef4444" />
      <circle cx="16" cy="24" r="1.5" fill="#f59e0b" />
    </svg>
  </div>
);

/* ==========================================================================
   NEW YEAR ICONS (Midnight Celebration)
   ========================================================================== */

export const NewYearChampagneIcon = ({ className = 'w-4 h-4', style = {}, ...props }) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} style={style} {...props}>
    <path d="M8 3 L11 11 C11 13 9 14 8 14 C7 14 5 13 5 11 L8 3 Z" fill="rgba(245, 158, 11, 0.4)" stroke="#f59e0b" strokeWidth="1.2" />
    <path d="M8 14 L8 21 M5 21 L11 21" stroke="#f59e0b" strokeWidth="1.2" strokeLinecap="round" />
    <path d="M16 3 L13 11 C13 13 15 14 16 14 C17 14 19 13 19 11 L16 3 Z" fill="rgba(245, 158, 11, 0.4)" stroke="#f59e0b" strokeWidth="1.2" />
    <path d="M16 14 L16 21 M13 21 L19 21" stroke="#f59e0b" strokeWidth="1.2" strokeLinecap="round" />
    <circle cx="12" cy="5" r="1" fill="#fde047" />
    <circle cx="10" cy="2" r="0.8" fill="#fef08a" />
    <circle cx="14" cy="2" r="0.8" fill="#fef08a" />
  </svg>
);

export const NewYearStarIcon = ({ className = 'w-4 h-4', style = {}, ...props }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} style={style} {...props}>
    <polygon points="12,2 14.5,8.5 21,9.5 16,14.5 17.5,21 12,17.5 6.5,21 8,14.5 3,9.5 9.5,8.5" fill="#f59e0b" />
  </svg>
);

export const NewYearCardCornerBurst = ({ className = 'w-9 h-9' }) => (
  <div className="absolute top-0 right-0 pointer-events-none z-10 opacity-75 group-hover:opacity-100 transition-opacity">
    <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M36 0 L14 0 C14 12 24 22 36 22 Z" fill="rgba(245, 158, 11, 0.12)" />
      <line x1="36" y1="0" x2="16" y2="20" stroke="#f59e0b" strokeWidth="1" strokeDasharray="3 2" />
      <circle cx="28" cy="8" r="1.8" fill="#fde047" />
      <circle cx="20" cy="14" r="1.2" fill="#818cf8" />
      <polygon points="32,16 33,18 35,18.5 33.5,20 34,22 32,21 30,22 30.5,20 29,18.5 31,18" fill="#f59e0b" />
    </svg>
  </div>
);

/* ==========================================================================
   VALENTINES ICONS (Romantic Neon)
   ========================================================================== */

export const ValentinesHeartIcon = ({ className = 'w-4 h-4', style = {}, ...props }) => (
  <svg viewBox="0 0 24 24" fill="url(#pshValHeartGradCard)" xmlns="http://www.w3.org/2000/svg" className={className} style={style} {...props}>
    <defs>
      <linearGradient id="pshValHeartGradCard" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fb7185" />
        <stop offset="100%" stopColor="#e11d48" />
      </linearGradient>
    </defs>
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" stroke="#f43f5e" strokeWidth="0.8" />
  </svg>
);

export const ValentinesCardCornerSwirl = ({ className = 'w-9 h-9' }) => (
  <div className="absolute top-0 right-0 pointer-events-none z-10 opacity-75 group-hover:opacity-100 transition-opacity">
    <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M36 0 L15 0 C15 11.5 24.5 21 36 21 Z" fill="rgba(244, 63, 94, 0.12)" />
      <path d="M36 0 C26 0 18 8 18 18 C18 24 22 28 26 28 C30 28 33 25 33 22" stroke="#f43f5e" strokeWidth="1" strokeDasharray="3 1.5" />
      <circle cx="28" cy="8" r="1.5" fill="#fb7185" />
      <path d="M22 14 C21 12.5 19 12.5 18 13.5 C17 12.5 15 12.5 14 13.5 C14 15 18 18 18 18 C18 18 22 15 22 14 Z" fill="#f43f5e" />
    </svg>
  </div>
);

/* ==========================================================================
   BLACK FRIDAY ICONS (Cyber Drop)
   ========================================================================== */

export const BlackFridayBoltIcon = ({ className = 'w-4 h-4', style = {}, ...props }) => (
  <svg viewBox="0 0 24 24" fill="url(#pshBfBoltGradCard)" xmlns="http://www.w3.org/2000/svg" className={className} style={style} {...props}>
    <defs>
      <linearGradient id="pshBfBoltGradCard" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#22d3ee" />
        <stop offset="100%" stopColor="#0891b2" />
      </linearGradient>
    </defs>
    <polygon points="13,2 3,14 12,14 11,22 21,10 12,10" stroke="#00f0ff" strokeWidth="0.8" />
  </svg>
);

export const BlackFridayCardCornerGrid = ({ className = 'w-9 h-9' }) => (
  <div className="absolute top-0 right-0 pointer-events-none z-10 opacity-75 group-hover:opacity-100 transition-opacity">
    <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <polygon points="36,0 12,0 36,24" fill="rgba(6, 182, 212, 0.15)" />
      <line x1="36" y1="6" x2="18" y2="6" stroke="#00f0ff" strokeWidth="0.8" />
      <line x1="36" y1="12" x2="24" y2="12" stroke="#00f0ff" strokeWidth="0.8" />
      <line x1="36" y1="18" x2="30" y2="18" stroke="#00f0ff" strokeWidth="0.8" />
      <line x1="30" y1="0" x2="30" y2="18" stroke="#00f0ff" strokeWidth="0.8" />
      <line x1="24" y1="0" x2="24" y2="12" stroke="#00f0ff" strokeWidth="0.8" />
      <line x1="18" y1="0" x2="18" y2="6" stroke="#00f0ff" strokeWidth="0.8" />
      <circle cx="28" cy="8" r="1.2" fill="#ef4444" />
    </svg>
  </div>
);

/* ==========================================================================
   EID ICONS (Luminous Celebration)
   ========================================================================== */

export const EidCrescentIcon = ({ className = 'w-4 h-4', style = {}, ...props }) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} style={style} {...props}>
    <path d="M12 3 C7.5 3 4 6.8 4 11.5 C4 16.2 7.8 20 12.5 20 C14.5 20 16.3 19.3 17.8 18.2 C14.2 17.5 11.5 14.3 11.5 10.5 C11.5 7.2 13.5 4.4 16.5 3.4 C15.1 3.1 13.6 3 12 3 Z" fill="#10b981" stroke="#34d399" strokeWidth="0.8" />
    <polygon points="18,6 19,8 21,8.3 19.5,9.7 20,11.7 18,10.6 16,11.7 16.5,9.7 15,8.3 17,8" fill="#f59e0b" />
  </svg>
);

export const EidCardCornerArch = ({ className = 'w-9 h-9' }) => (
  <div className="absolute top-0 right-0 pointer-events-none z-10 opacity-75 group-hover:opacity-100 transition-opacity">
    <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M36 0 L14 0 C14 12 24 22 36 22 Z" fill="rgba(16, 185, 129, 0.12)" />
      <path d="M36 0 C24 0 16 8 16 20 C16 24 20 28 24 28 C28 28 32 24 32 20" stroke="#10b981" strokeWidth="1" strokeDasharray="3 1.5" />
      <circle cx="28" cy="8" r="1.5" fill="#f59e0b" />
      <circle cx="22" cy="14" r="1.2" fill="#34d399" />
    </svg>
  </div>
);

/* ==========================================================================
   SUMMER SALE ICONS (Tropical Energy)
   ========================================================================== */

export const SummerSunIcon = ({ className = 'w-4 h-4', style = {}, ...props }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" className={className} style={style} {...props}>
    <circle cx="12" cy="12" r="5" fill="#f59e0b" stroke="#d97706" strokeWidth="1" />
    <line x1="12" y1="1" x2="12" y2="4" stroke="#f59e0b" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="12" y1="20" x2="12" y2="23" stroke="#f59e0b" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="4.22" y1="4.22" x2="6.34" y2="6.34" stroke="#f59e0b" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="17.66" y1="17.66" x2="19.78" y2="19.78" stroke="#f59e0b" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="1" y1="12" x2="4" y2="12" stroke="#f59e0b" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="20" y1="12" x2="23" y2="12" stroke="#f59e0b" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="4.22" y1="19.78" x2="6.34" y2="17.66" stroke="#f59e0b" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="17.66" y1="6.34" x2="19.78" y2="4.22" stroke="#f59e0b" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const SummerCardCornerSunburst = ({ className = 'w-9 h-9' }) => (
  <div className="absolute top-0 right-0 pointer-events-none z-10 opacity-75 group-hover:opacity-100 transition-opacity">
    <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M36 0 L15 0 C15 11.5 24.5 21 36 21 Z" fill="rgba(6, 182, 212, 0.12)" />
      <path d="M36 0 C24 0 16 8 16 20 C16 26 22 30 28 30" stroke="#06b6d4" strokeWidth="1" strokeDasharray="3 1.5" />
      <circle cx="28" cy="8" r="2" fill="#f59e0b" />
      <circle cx="20" cy="16" r="1.2" fill="#06b6d4" />
    </svg>
  </div>
);

/* ==========================================================================
   UNIFIED THEME CORNER DECORATION
   ========================================================================== */

export const ThemeCardCornerDecoration = ({ activeTheme, className = 'w-8 h-8 sm:w-9 sm:h-9' }) => {
  switch (activeTheme) {
    case 'halloween':
      return <HalloweenCardCornerWeb className={className} />;
    case 'christmas':
      return <ChristmasCardCornerFrost className={className} />;
    case 'diwali':
      return <DiwaliCardCornerRangoli className={className} />;
    case 'newyear':
      return <NewYearCardCornerBurst className={className} />;
    case 'valentines':
      return <ValentinesCardCornerSwirl className={className} />;
    case 'blackfriday':
      return <BlackFridayCardCornerGrid className={className} />;
    case 'eid':
      return <EidCardCornerArch className={className} />;
    case 'summersale':
      return <SummerCardCornerSunburst className={className} />;
    default:
      return null;
  }
};

/* ==========================================================================
   UNIFIED THEME SEASONAL BADGE (Top-left or bottom-left on card image)
   ========================================================================== */

export const ThemeCardSeasonalBadge = ({ activeTheme, isCompact = false, isMobile = false }) => {
  const isSmall = isCompact || isMobile;

  switch (activeTheme) {
    case 'halloween':
      return (
        <div className="flex items-center gap-1 sm:gap-1.5 rounded-full bg-gradient-to-r from-orange-600 via-amber-600 to-purple-800 px-2 py-0.5 text-[9px] sm:text-[10px] font-black text-white shadow-md border border-orange-400/60 backdrop-blur-sm">
          <HalloweenPumpkinIcon className="w-2.5 h-2.5 sm:w-3 sm:h-3" />
          <span className="uppercase tracking-wider">{isSmall ? 'Spooky' : 'Spooky Pick'}</span>
        </div>
      );

    case 'christmas':
      return (
        <div className="flex items-center gap-1 sm:gap-1.5 rounded-full bg-gradient-to-r from-sky-600 via-blue-700 to-emerald-700 px-2 py-0.5 text-[9px] sm:text-[10px] font-black text-white shadow-md border border-sky-300/60 backdrop-blur-sm">
          <ChristmasSnowflakeIcon className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-sky-200" />
          <span className="uppercase tracking-wider">{isSmall ? 'Holiday' : 'Holiday Pick'}</span>
        </div>
      );

    case 'diwali':
      return (
        <div className="flex items-center gap-1 sm:gap-1.5 rounded-full bg-gradient-to-r from-amber-600 via-red-600 to-amber-700 px-2 py-0.5 text-[9px] sm:text-[10px] font-black text-white shadow-md border border-yellow-300/70 backdrop-blur-sm">
          <DiwaliDiyaIcon className="w-2.5 h-2.5 sm:w-3 sm:h-3" />
          <span className="uppercase tracking-wider">{isSmall ? 'Diwali' : 'Diwali Special'}</span>
        </div>
      );

    case 'newyear':
      return (
        <div className="flex items-center gap-1 sm:gap-1.5 rounded-full bg-gradient-to-r from-amber-500 via-indigo-600 to-purple-700 px-2 py-0.5 text-[9px] sm:text-[10px] font-black text-white shadow-md border border-amber-300/60 backdrop-blur-sm">
          <NewYearChampagneIcon className="w-2.5 h-2.5 sm:w-3 sm:h-3" />
          <span className="uppercase tracking-wider">{isSmall ? 'NY Pick' : 'New Year Pick'}</span>
        </div>
      );

    case 'valentines':
      return (
        <div className="flex items-center gap-1 sm:gap-1.5 rounded-full bg-gradient-to-r from-rose-600 via-pink-600 to-red-700 px-2 py-0.5 text-[9px] sm:text-[10px] font-black text-white shadow-md border border-rose-300/60 backdrop-blur-sm">
          <ValentinesHeartIcon className="w-2.5 h-2.5 sm:w-3 sm:h-3" />
          <span className="uppercase tracking-wider">{isSmall ? 'Cupid' : "Cupid's Pick"}</span>
        </div>
      );

    case 'blackfriday':
      return (
        <div className="flex items-center gap-1 sm:gap-1.5 rounded-full bg-gradient-to-r from-cyan-600 via-slate-900 to-red-600 px-2 py-0.5 text-[9px] sm:text-[10px] font-black text-white shadow-md border border-cyan-400/70 backdrop-blur-sm">
          <BlackFridayBoltIcon className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-cyan-200" />
          <span className="uppercase tracking-wider">{isSmall ? 'Drop' : 'Cyber Drop'}</span>
        </div>
      );

    case 'eid':
      return (
        <div className="flex items-center gap-1 sm:gap-1.5 rounded-full bg-gradient-to-r from-emerald-600 via-teal-700 to-amber-700 px-2 py-0.5 text-[9px] sm:text-[10px] font-black text-white shadow-md border border-emerald-300/60 backdrop-blur-sm">
          <EidCrescentIcon className="w-2.5 h-2.5 sm:w-3 sm:h-3" />
          <span className="uppercase tracking-wider">{isSmall ? 'Eid' : 'Eid Special'}</span>
        </div>
      );

    case 'summersale':
      return (
        <div className="flex items-center gap-1 sm:gap-1.5 rounded-full bg-gradient-to-r from-cyan-600 via-amber-600 to-orange-600 px-2 py-0.5 text-[9px] sm:text-[10px] font-black text-white shadow-md border border-cyan-300/60 backdrop-blur-sm">
          <SummerSunIcon className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-amber-200" />
          <span className="uppercase tracking-wider">{isSmall ? 'Summer' : 'Summer Pick'}</span>
        </div>
      );

    default:
      return null;
  }
};

/* ==========================================================================
   UNIFIED THEME ACCENT ICON (Bottom-end of card image)
   ========================================================================== */

export const ThemeCardAccentIcon = ({ activeTheme }) => {
  switch (activeTheme) {
    case 'halloween':
      return <HalloweenBatIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-orange-400 drop-shadow-[0_1px_4px_rgba(0,0,0,0.9)]" />;
    case 'christmas':
      return <ChristmasSnowflakeIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-sky-300 drop-shadow-[0_1px_4px_rgba(0,0,0,0.9)]" />;
    case 'diwali':
      return <DiwaliSparklerIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-amber-400 drop-shadow-[0_1px_4px_rgba(0,0,0,0.9)]" />;
    case 'newyear':
      return <NewYearStarIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-amber-300 drop-shadow-[0_1px_4px_rgba(0,0,0,0.9)]" />;
    case 'valentines':
      return <ValentinesHeartIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-rose-400 drop-shadow-[0_1px_4px_rgba(0,0,0,0.9)]" />;
    case 'blackfriday':
      return <BlackFridayBoltIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-cyan-300 drop-shadow-[0_1px_4px_rgba(0,0,0,0.9)]" />;
    case 'eid':
      return <EidCrescentIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-emerald-400 drop-shadow-[0_1px_4px_rgba(0,0,0,0.9)]" />;
    case 'summersale':
      return <SummerSunIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-amber-300 drop-shadow-[0_1px_4px_rgba(0,0,0,0.9)]" />;
    default:
      return null;
  }
};

/* ==========================================================================
   STYLE HELPERS FOR PRODUCT CARDS (Glassmorphic + Theme-Tuned)
   ========================================================================== */

export const getThemeCardContainerClasses = (activeTheme, viewMode = 'grid') => {
  switch (activeTheme) {
    case 'halloween':
      return 'border-orange-500/35 bg-[#160a24]/42 backdrop-blur-md shadow-[0_6px_22px_rgba(0,0,0,0.65)] hover:border-orange-400 hover:bg-[#1a0c2e]/65 hover:shadow-[0_10px_32px_rgba(249,115,22,0.35)]';
    case 'christmas':
      return 'border-sky-500/35 bg-[#0a182a]/42 backdrop-blur-md shadow-[0_6px_22px_rgba(0,0,0,0.65)] hover:border-sky-400 hover:bg-[#0e223a]/65 hover:shadow-[0_10px_32px_rgba(56,189,248,0.35)]';
    case 'diwali':
      return 'border-amber-500/38 bg-[#1f0d06]/45 backdrop-blur-md shadow-[0_6px_22px_rgba(0,0,0,0.65)] hover:border-amber-400 hover:bg-[#2a1309]/68 hover:shadow-[0_10px_32px_rgba(245,158,11,0.38)]';
    case 'newyear':
      return 'border-amber-400/35 bg-[#120c28]/42 backdrop-blur-md shadow-[0_6px_22px_rgba(0,0,0,0.65)] hover:border-amber-300 hover:bg-[#191138]/65 hover:shadow-[0_10px_32px_rgba(245,158,11,0.35)]';
    case 'valentines':
      return 'border-rose-500/35 bg-[#200819]/42 backdrop-blur-md shadow-[0_6px_22px_rgba(0,0,0,0.65)] hover:border-rose-400 hover:bg-[#2b0c23]/65 hover:shadow-[0_10px_32px_rgba(244,63,94,0.35)]';
    case 'blackfriday':
      return 'border-cyan-500/40 bg-[#0b1019]/48 backdrop-blur-md shadow-[0_6px_22px_rgba(0,0,0,0.7)] hover:border-cyan-300 hover:bg-[#101825]/72 hover:shadow-[0_10px_32px_rgba(6,182,212,0.4)]';
    case 'eid':
      return 'border-emerald-500/35 bg-[#061e19]/45 backdrop-blur-md shadow-[0_6px_22px_rgba(0,0,0,0.65)] hover:border-emerald-400 hover:bg-[#0a2a23]/68 hover:shadow-[0_10px_32px_rgba(16,185,129,0.35)]';
    case 'summersale':
      return 'border-cyan-500/35 bg-[#081e2e]/45 backdrop-blur-md shadow-[0_6px_22px_rgba(0,0,0,0.65)] hover:border-orange-400 hover:bg-[#0c2a40]/68 hover:shadow-[0_10px_32px_rgba(6,182,212,0.35)]';
    default:
      return 'border-gray-100 bg-white shadow-sm hover:border-primary-200 hover:shadow-md dark:border-gray-800 dark:bg-gray-900 dark:hover:border-primary-500/40';
  }
};

export const getThemePriceClasses = (activeTheme) => {
  switch (activeTheme) {
    case 'halloween':
      return 'text-orange-400 drop-shadow-[0_0_8px_rgba(249,115,22,0.5)]';
    case 'christmas':
      return 'text-sky-300 drop-shadow-[0_0_8px_rgba(56,189,248,0.5)]';
    case 'diwali':
      return 'text-amber-400 drop-shadow-[0_0_8px_rgba(245,158,11,0.6)]';
    case 'newyear':
      return 'text-amber-300 drop-shadow-[0_0_8px_rgba(245,158,11,0.5)]';
    case 'valentines':
      return 'text-rose-400 drop-shadow-[0_0_8px_rgba(244,63,94,0.5)]';
    case 'blackfriday':
      return 'text-cyan-400 drop-shadow-[0_0_8px_rgba(6,182,212,0.6)]';
    case 'eid':
      return 'text-emerald-400 drop-shadow-[0_0_8px_rgba(16,185,129,0.5)]';
    case 'summersale':
      return 'text-cyan-300 drop-shadow-[0_0_8px_rgba(6,182,212,0.5)]';
    default:
      return 'text-primary-600 dark:text-primary-300';
  }
};

export const getThemeWishlistClasses = (activeTheme, isWishlisted = false) => {
  switch (activeTheme) {
    case 'halloween':
      return 'border-orange-500/50 bg-[#1c0d2e]/80 text-orange-300 hover:text-red-400 hover:border-orange-400 shadow-[0_0_8px_rgba(249,115,22,0.25)]';
    case 'christmas':
      return 'border-sky-500/50 bg-[#0d2238]/80 text-sky-300 hover:text-red-400 hover:border-sky-400 shadow-[0_0_8px_rgba(56,189,248,0.25)]';
    case 'diwali':
      return 'border-amber-500/50 bg-[#251007]/80 text-amber-300 hover:text-red-400 hover:border-amber-400 shadow-[0_0_8px_rgba(245,158,11,0.25)]';
    case 'newyear':
      return 'border-amber-400/50 bg-[#1a1236]/80 text-amber-300 hover:text-red-400 hover:border-amber-300 shadow-[0_0_8px_rgba(245,158,11,0.25)]';
    case 'valentines':
      return 'border-rose-500/50 bg-[#260a1f]/80 text-rose-300 hover:text-rose-100 hover:border-rose-400 shadow-[0_0_8px_rgba(244,63,94,0.25)]';
    case 'blackfriday':
      return 'border-cyan-500/50 bg-[#0e1622]/80 text-cyan-300 hover:text-red-400 hover:border-cyan-400 shadow-[0_0_8px_rgba(6,182,212,0.25)]';
    case 'eid':
      return 'border-emerald-500/50 bg-[#08241e]/80 text-emerald-300 hover:text-amber-300 hover:border-emerald-400 shadow-[0_0_8px_rgba(16,185,129,0.25)]';
    case 'summersale':
      return 'border-cyan-500/50 bg-[#0a2538]/80 text-cyan-300 hover:text-orange-300 hover:border-cyan-400 shadow-[0_0_8px_rgba(6,182,212,0.25)]';
    default:
      return 'border-gray-100 bg-gray-50 hover:bg-red-50 dark:border-gray-800 dark:bg-gray-950 dark:hover:bg-red-500/10 text-gray-600 dark:text-gray-400';
  }
};
